import { type Switch, AppSwitch } from '~~/entities/switch'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const switches = useState<Switch[]>('switches')

  if (!switches.value) {
    switches.value = await $fetch<Switch[]>('/v2/switches', useFetchSharedOptions())
  }

  if (switches.value.find(x => x.name.includes(AppSwitch.MAINTENANCE))?.active && !to.path.includes('maintenance')) {
    return navigateTo('/maintenance')
  }
})
